/**
 * Created by Yaroslav S. on 02/05/24.
 * Copyright © 2024 SEVEN. All rights reserved.
 */

import { Component, OnInit, Input } from '@angular/core';
import { Question, QuestionsLabels, QuestionType } from '../../../../../student/test.model';
import {forkJoin, Observable, timer} from 'rxjs';
import { FileUploadService } from '../../../../../shared/components/edit-question-block/file-upload.service';
import {take} from 'rxjs/operators';

@Component({
  selector: 'curr-my-question-item',
  templateUrl: './my-question-item.component.html',
  styleUrls: ['./my-question-item.component.scss']
})
export class MyQuestionItemComponent implements OnInit {
  @Input() question: Question;
  @Input() isFirstLevel: boolean = true;

  questionType = QuestionType;
  questionsLabels = QuestionsLabels;

  isLoading = false;

  constructor(private fileUploadService: FileUploadService) {}

  ngOnInit() {
    if (this.question.question.includes('<img src')) {
      this.getQuestionDescription(this.question);
    }
  }

  isOpenAnswer() {
    return (
      this.question?.answer_type === this.questionType.SELECT_ONE ||
      this.question?.answer_type === this.questionType.SELECT_MULTIPLE ||
      this.question?.answer_type === this.questionType.TRUE_OR_FALSE
    );
  }

  isAnswerCorrect(i: number) {
    if (!this.question || !this.question.correct_answer_options) {
      return false;
    }
    if (this.question?.answer_type === this.questionType.SELECT_ONE) {
      return this.question?.correct_answer_options[0] === i;
    }
    if (this.question?.answer_type === this.questionType.TRUE_OR_FALSE) {
      return this.question?.correct_answer_options[0] === i;
    }
    if (this.question?.answer_type === this.questionType.SELECT_MULTIPLE) {
      return this.question?.correct_answer_options.filter(a => a === i).length;
    }
  }

  getQuestionTypeLabel() {
    return this.questionsLabels[this.question.answer_type] || '';
  }

  getQuestionDescription(question: Question) {
    if (question.question.includes('<img src')) {
      const imageKeyValue = this.fileUploadService.getAllImageKeysFromNote(question.question);
      this.uploadImages(imageKeyValue, question);
    }
    return question.question;
  }

  private async uploadImages(imageKeyValue: any, q: Question) {
    this.isLoading = true;
    let previewQuestion = q.question;

    const observersObj: { [key: string]: Observable<any> } = {};

    for (const key of Object.keys(imageKeyValue)) {
      observersObj[key] = this.fileUploadService.download(key, 'IMAGE');
    }

    forkJoin(observersObj).subscribe({
      next: (res: any) => {
        for (const [key, value] of Object.entries(res)) {
          const bytes = (value as any)?.data?.bytes;
          imageKeyValue[key] = 'data:image/png;base64,' + bytes;
          previewQuestion = previewQuestion.replace(key, imageKeyValue[key]);
        }
      },
      complete: () => {
        this.isLoading = false;
        q.question = previewQuestion;
        this.setImgWidth();
      }
    });
  }

  setImgWidth() {
    timer(0)
      .pipe(take(1))
      .subscribe(resp => {
        const root = document.getElementById(`desc-${ this.question.id }`);
        const allImgs = root?.querySelectorAll('img');
        const rw = root?.offsetWidth;
        if (allImgs?.length) {
          allImgs.forEach(e => {
            if (e.width > rw) {
              // For mobile, decrease width
              e.setAttribute('width', '100%');
            }
          });
        }
      });
  }
}
